import { urijs } from '@wix/communities-blog-client-common';

interface Topology {
  baseUrl?: string;
  postPagePath?: string;
  postPageSectionUrl?: string;
}

const getPostUrl = (topology: Topology, paths: string[]) =>
  urijs
    .joinPaths(
      urijs(topology.baseUrl as string).pathname(),
      topology.postPagePath as string,
      ...paths,
    )
    .absoluteTo(topology.baseUrl as string)
    .toString();

export default getPostUrl;
